export default __webpack_public_path__ + "static/media/APY Dark mode.0cb1d07a.png";